// La cuenta de demostracion (users.is_superuser): la de la pantalla grande, con
// la que se ensena a jugar. Puede avanzar en la cata sin elegir nada, sus catas
// no se guardan y en "Respuestas" abre las correctas de los vinos ya cerrados.
// El backend la deja fuera de clasificaciones y winegangs por su cuenta.
export const esPresentador = () => {
    try {
        return Boolean(JSON.parse(localStorage.getItem('userLogged'))?.presentador);
    } catch (e) {
        return false;
    }
};

// Lo que guarda el login (y refresca Home) a partir del usuario del backend
export const marcaPresentador = (user) => Boolean(Number(user.is_superuser));
